export const room = {
  groupName: {
    label: 'Ime grupe',
    create: 'Izmislite ime svoje grupe',
  },
  name: {
    label: 'Ime',
    your: 'Tvoje ime',
  },
  actions: {
    create: 'Pripremite sobu',
    scanCode: 'Skenirajte šifru sobe ',
    enter: 'Uđi u sobu',
    start: 'Započni s prvom sobom',
  },

  members: 'Članovi grupe u sobi',

  welcome: {
    part1: 'Želimo ti dobrodošlicu, {{name}},',
    part2: 'pričekaj koji trenutak dok igra ne počne.',
  },

  instructions: {
    read: 'Sada u sebi pročitaj primjere koji su se pojavili na tvom pametnom telefonu.',
    ready:
      'Kada svi budu spremni, možeš ući u sobu. Objasni svoj primjer kada se pojavi na ekranu. Rastumači ga svojim riječima. Za prelazak na sljedeći primjer, klikni na navigacijsko dugme na vrhu ekrana.',
    listen: "Poslušaj ostale. Sada je red na tvoje kolege iz grupe.",
    continue: 'Prošli smo sve primjere. Čestitke na tome! Sada nastavi s EDU boxom.',
  },
  closed: 'Soba je zatvorena',
};
